import { Component, Input, OnChanges, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { DriverDetails, PaginationParams } from '@app-driver-management/common/driver-management.model';
import { GoogleTagManagerService } from '@app-core/services/google-tag-manager/google-tag-manager.service';
import { DriverManagementService } from '@app-driver-management/services/driver-management.service';
import { finalize, switchMap, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '@app-core/services/snackbar/snack-bar.service';
import { EMPTY, Observable, Subject } from 'rxjs';
import { ConfirmDialogComponent } from '@app-shared/components/dialog/confirm-dialog/confirm-dialog.component';
import { INSTALLER_TABLE_COLUMNS, InstallerStatus } from '@app-driver-management/common/Installer.constants';
import { PAGE_OPTION } from '@app-driver-management/common/driver-management.constants';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';
@Component({
  selector: 'app-installer-list',
  templateUrl: './installer-list.component.html',
  styleUrls: ['./installer-list.component.scss'],
})
export class InstallerListComponent implements OnChanges {
  @Input()
  public installerList = [];
  @Input() public pageSize: number = 0;
  @Input()
  public totalCountOfDrivers: number = 0;
  public tableSource: MatTableDataSource<any> = new MatTableDataSource([]);
  displayedColumns: string[] = INSTALLER_TABLE_COLUMNS;
  public isClientSidePaginated: boolean = false;
  @Output() dorefresh = new EventEmitter<void>();
  @Output() pageChange = new EventEmitter<PaginationParams>();
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @Input()
  public fleetId: string;
  @Input()
  public loader;
  public pageSizeOptions: number[] = PAGE_OPTION;
  InstallerStatus = InstallerStatus;
  ngOnInit() {
    if (this.installerList && this.installerList.length > 0) {
      this.tableSource.data = this.installerList;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.installerList) {
      this.tableSource.data = this.installerList;
    }
  }
  constructor(
    public dialog: MatDialog,
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private driverManagementService: DriverManagementService,
    private translate: TranslateService,
    private snackbarService: SnackBarService,
    private mixpanelService: MixPanelService
  ) {}

  public deleteInstallerDetails(element): Observable<any> {
    const { driverId, email = '' } = element || {};
    const username = email?.length > 0 ? email : driverId;
    this.mixpanelService.track('Deleting Installer', {
      'Driver Id': driverId,
    });
    const params = {
      userType: 'DRIVER',
    };

    return this.driverManagementService.deleteDriver(params, username).pipe(
      finalize(() => {}),
      takeUntil(this.ngUnsubscribe)
    );
  }
  public deleteInstaller(element) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      position: { top: '24px' },
      minHeight: '200px',
      width: '332px',
      maxWidth: 'none',
      panelClass: ['delete-modal'],
      data: {
        title: this.translate.instant('Are you Sure?'),
        content: this.translate.instant(
          'This action cannot be undone. The installer will be deleted access, to the app will be revoked, and all data will be lost.'
        ),
        actions: [
          { actionButton: this.translate.instant('CANCEL'), dialogCloseValue: false },
          { actionButton: this.translate.instant('DELETE'), dialogCloseValue: true, primary: true },
        ],
      },
    });
    dialogRef
      .afterClosed()
      .pipe(
        takeUntil(this.ngUnsubscribe),
        switchMap((confirmDelete: boolean) => {
          return confirmDelete ? this.deleteInstallerDetails(element) : EMPTY;
        })
      )
      .subscribe(
        () => {
          if (element?.appMetadata.userType === 'INSTALLER') {
            this.snackbarService.success(this.translate.instant('driverManagementInstallerDeleteSuccess'));
          } else {
            this.snackbarService.success(this.translate.instant('driverManagementDriverDeleteSuccess'));
          }
          this.dorefresh.emit();
        },
        () => {
          this.snackbarService.failure(this.translate.instant('driverManagementDriverDeleteFailed'));
        }
      );
  }
  public resendTempPasswordEmail(driver: DriverDetails) {
    driver.loader = true;
    const body = {
      email: driver.email,
    };
    this.mixpanelService.track('Resend Temporary Password Email ', {
      Email: driver.email,
    });
    this.gtmService.resendDriverTempPassword(this.fleetId);
    this.driverManagementService
      .resendDriverTempPassword(body)
      .pipe(
        finalize(() => {
          driver.loader = false;
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(
        () => {
          this.snackbarService.success(this.translate.instant('driverManagementTempPasswordSuccess'));
        },
        () => {
          this.snackbarService.failure(this.translate.instant('driverManagementEmailFailed'));
        }
      );
  }
  public navigateToEditInstaller(element) {
    this.router.navigate(['drivers/edit-installer'], {
      queryParams: {
        mode: 'edit',
        installerId: element.driverId,
        installerName: element.driverName,
        email: element.email,
      },
    });
  }
  onPageChange(event: PageEvent) {
    const limit = event.pageSize;
    const offset = event.pageIndex * event.pageSize;
    this.pageChange.emit({ limit, offset });
  }
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
